import React, {Component} from 'react';
import PickContextProvider from "./context/PickContext";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import PickFilterContextProvider from "./context/PickFilterContext";
import PickView from "./PickView";
import AssociateContextProvider from "../associate/context/AssociateContextProvider";
import DWPFileContextProvider from "../fileupload/context/DWPUploadContext";
import AlertContextProvider from "../alert/context/AlertContext";
import {PickViewSelectorContextProvider} from "./context/PickViewSelectorContext";

class Pick extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <AlertContextProvider>
                    <PickFilterContextProvider context = {this.props.match.params.context}>
                        <PickContextProvider>
                            <DWPFileContextProvider>
                                <AssociateContextProvider>
                                    <PickViewSelectorContextProvider>
                                        <PickView history={this.props.history}/>
                                    </PickViewSelectorContextProvider>
                                </AssociateContextProvider>
                            </DWPFileContextProvider>
                        </PickContextProvider>
                    </PickFilterContextProvider>
                </AlertContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default Pick;


// WEBPACK FOOTER //
// ./src/components/pickStatus/Pick.js